import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class DownloadDataApiExcelService {
  constructor(private http: HttpClient) {}

  getFileData(endpoint: string): Observable<any> {
    return this.http.post<any>(
      `${environment.microserviceParts}${endpoint}`,
      null,
      {
        observe: "response",
        responseType: "blob" as "json"
      }
    );
  }
}
